module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic08.459985b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic08.png
// module id = 526
// module chunks = 1